import React from "react";
import { TABS_ID } from "../DesktopNavigation";

const tabs = [
  { id: TABS_ID.GAMES, label: 'Games' },
  { id: TABS_ID.STANDINGS, label: 'Standings' },
  { id: TABS_ID.TEAMS, label: 'Teams' }
];

const MobileTabNavigation = ({ activeTab, onChange, t }) => {
  return (
    <div className="grid grid-cols-3 gap-2">
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`rounded-xl border px-3 py-2 text-xs font-semibold uppercase tracking-wide transition-all ${
              isActive
                ? 'bg-white text-black border-white shadow-[0_10px_25px_rgba(0,0,0,0.35)]'
                : 'bg-white/5 text-white/70 border-white/10'
            }`}
          >
            {t(tab.label)}
          </button>
        );
      })}
    </div>
  );
};

export default MobileTabNavigation;
